export const c_pagination__nav_page_select_c_form_control_width_chars = {
  "name": "--pf-v5-c-pagination__nav-page-select--c-form-control--width-chars",
  "value": "2",
  "var": "var(--pf-v5-c-pagination__nav-page-select--c-form-control--width-chars)"
};
export default c_pagination__nav_page_select_c_form_control_width_chars;